import {
  CreateMenulyticsReportDto,
  MenulyticsReport,
  ShareMenulyticsReportDto,
  ShareMenulyticsReportResponse,
} from '../types/api/menulytics.types';
import { ResponseType } from '../types/shared.types';
import { api } from './api';

/** The last 20, newest first. */
export const getMenulyticsReports = (locationId: string | number) =>
  api.get<ResponseType<MenulyticsReport[]>>(
    `/v2/locations/${locationId}/menulytics-reports`
  );

/**
 * The current state, asking Menulytics while it is still running. Only a
 * fallback for when the menu socket is down - never poll it while it is up.
 */
export const getMenulyticsReport = (
  locationId: string | number,
  reportId: number
) =>
  api.get<ResponseType<MenulyticsReport>>(
    `/v2/locations/${locationId}/menulytics-reports/${reportId}`
  );

/**
 * Answers with a `queued` report. When neither the menu nor the sales changed
 * it answers with the SAME report (same id, possibly already `completed`).
 */
export const createMenulyticsReport = (
  locationId: string | number,
  data: CreateMenulyticsReportDto
) =>
  api.post<ResponseType<MenulyticsReport>>(
    `/v2/locations/${locationId}/menulytics-reports`,
    data
  );

/** `failed` reports only. */
export const retryMenulyticsReport = (
  locationId: string | number,
  reportId: number
) =>
  api.post<ResponseType<MenulyticsReport>>(
    `/v2/locations/${locationId}/menulytics-reports/${reportId}/retry`
  );

/** `completed`, unexpired reports only. The owner is always the recipient. */
export const shareMenulyticsReport = (
  locationId: string | number,
  reportId: number,
  data: ShareMenulyticsReportDto
) =>
  api.post<ResponseType<ShareMenulyticsReportResponse>>(
    `/v2/locations/${locationId}/menulytics-reports/${reportId}/share`,
    data
  );
